(function(){
  var body=document.body;
  var menu=document.getElementById('gtMenu');
  var menuButton=document.querySelector('.gt-menu-button');
  var menuClose=document.querySelector('.gt-menu-close');
  var menuShade=document.querySelector('.gt-menu-shade');
  var lastMenuTrigger=null;
  function setMenu(open){
    if(!menu)return;
    var wasOpen=menu.classList.contains('is-open');
    if(open&&!wasOpen)lastMenuTrigger=document.activeElement||menuButton;
    menu.classList.toggle('is-open',open);
    menu.setAttribute('aria-hidden',String(!open));
    if(menuButton)menuButton.setAttribute('aria-expanded',String(open));
    if(menuShade)menuShade.hidden=!open;
    body.classList.toggle('gt-lock',open);
    if(open&&!wasOpen){setTimeout(function(){if(menuClose)menuClose.focus()},50)}
    if(!open&&wasOpen&&lastMenuTrigger){lastMenuTrigger.focus();lastMenuTrigger=null}
  }
  if(menuButton)menuButton.addEventListener('click',function(){setMenu(true)});
  if(menuClose)menuClose.addEventListener('click',function(){setMenu(false)});
  if(menuShade)menuShade.addEventListener('click',function(){setMenu(false)});
  if(menu)menu.addEventListener('click',function(e){if(e.target.closest('a'))setMenu(false)});

  var access=document.getElementById('gtAccess');
  var lastAccessTrigger=null;
  function setAccess(open){
    if(!access)return;
    var wasOpen=access.classList.contains('is-open');
    access.classList.toggle('is-open',open);
    access.setAttribute('aria-hidden',String(!open));
    body.classList.toggle('gt-lock',open);
    if(open){var input=access.querySelector('input[type=email]');setTimeout(function(){if(input)input.focus()},80)}
    if(!open&&wasOpen&&lastAccessTrigger){lastAccessTrigger.focus();lastAccessTrigger=null}
  }
  document.querySelectorAll('[data-open-access]').forEach(function(button){button.addEventListener('click',function(){lastAccessTrigger=button;setAccess(true)})});
  if(access){
    access.querySelector('.gt-access-close').addEventListener('click',function(){setAccess(false)});
    access.querySelector('.gt-access-shade').addEventListener('click',function(){setAccess(false)});
  }

  var ingredientModal=document.getElementById('gtIngredientModal');
  var ingredientContent=ingredientModal&&ingredientModal.querySelector('.gt-ingredient-modal-content');
  var lastIngredientTrigger=null;
  function setIngredient(open,trigger){
    if(!ingredientModal)return;
    if(open&&trigger){
      var template=document.getElementById(trigger.getAttribute('data-ingredient-detail'));
      if(!template)return;
      lastIngredientTrigger=trigger;
      ingredientContent.innerHTML='';
      var image=trigger.querySelector('img');
      if(image){
        var modalMedia=document.createElement('div');
        modalMedia.className='gt-ingredient-modal-media';
        var modalImage=image.cloneNode();
        modalImage.className='gt-ingredient-modal-image';
        modalImage.alt=(trigger.querySelector('strong')?trigger.querySelector('strong').textContent:'Ingredient')+' visual';
        modalMedia.appendChild(modalImage);
        ingredientContent.appendChild(modalMedia);
      }
      ingredientContent.appendChild(template.content.cloneNode(true));
    }
    ingredientModal.classList.toggle('is-open',open);
    ingredientModal.setAttribute('aria-hidden',String(!open));
    body.classList.toggle('gt-lock',open);
    if(open){
      setTimeout(function(){var close=ingredientModal.querySelector('.gt-ingredient-modal-close');if(close)close.focus()},50);
    }else if(lastIngredientTrigger){
      lastIngredientTrigger.focus();
      lastIngredientTrigger=null;
    }
  }
  document.querySelectorAll('[data-ingredient-detail]').forEach(function(card){
    card.addEventListener('click',function(){setIngredient(true,card)});
  });
  document.querySelectorAll('[data-close-ingredient]').forEach(function(close){
    close.addEventListener('click',function(){setIngredient(false)});
  });

  var ingredientFilters=[].slice.call(document.querySelectorAll('[data-ingredient-filter]'));
  var ingredientCards=[].slice.call(document.querySelectorAll('[data-ingredient-category]'));
  var ingredientCount=document.querySelector('[data-ingredient-count]');
  ingredientFilters.forEach(function(filterButton){
    filterButton.addEventListener('click',function(){
      var selected=filterButton.getAttribute('data-ingredient-filter');
      ingredientFilters.forEach(function(button){
        var active=button===filterButton;
        button.classList.toggle('is-active',active);
        button.setAttribute('aria-pressed',String(active));
      });
      var visible=0;
      ingredientCards.forEach(function(card){
        var show=selected==='all'||card.getAttribute('data-ingredient-category')===selected;
        card.hidden=!show;
        if(show)visible++;
      });
      if(ingredientCount)ingredientCount.textContent=String(visible);
    });
  });

  var researchFilters=[].slice.call(document.querySelectorAll('[data-research-filter]'));
  var researchCards=[].slice.call(document.querySelectorAll('[data-research-category]'));
  var researchCount=document.querySelector('[data-research-count]');
  researchFilters.forEach(function(filterButton){
    filterButton.addEventListener('click',function(){
      var selected=filterButton.getAttribute('data-research-filter');
      researchFilters.forEach(function(button){
        var active=button===filterButton;
        button.classList.toggle('is-active',active);
        button.setAttribute('aria-pressed',String(active));
      });
      var visible=0;
      researchCards.forEach(function(card){
        var show=selected==='all'||card.getAttribute('data-research-category')===selected;
        card.hidden=!show;
        card.classList.toggle('gt-study--feature',show&&selected==='all'&&visible===0);
        if(show)visible++;
      });
      if(researchCount)researchCount.textContent=String(visible);
    });
  });

  document.addEventListener('keydown',function(e){if(e.key==='Escape'){setMenu(false);setAccess(false);setIngredient(false)}});

  if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window){
    var els=[].slice.call(document.querySelectorAll('[data-reveal]'));
    els.forEach(function(el){
      var style=el.getAttribute('data-reveal');
      var order=parseInt(el.getAttribute('data-reveal-order')||'0',10);
      el.style.opacity='0';
      el.style.transform=style==='left'?'translateX(-28px)':style==='scale'?'scale(.965)':'translateY(24px)';
      el.style.transition='opacity .72s ease,transform .82s cubic-bezier(.2,.7,.2,1)';
      el.style.transitionDelay=(Math.min(order,6)*70)+'ms';
    });
    var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.style.opacity='1';entry.target.style.transform='none';observer.unobserve(entry.target)}})},{threshold:.08,rootMargin:'0px 0px -5%'});
    els.forEach(function(el){observer.observe(el)});
  }

  var counters=[].slice.call(document.querySelectorAll('[data-count]'));
  if(counters.length){
    var reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    counters.forEach(function(counter){
      var target=parseInt(counter.getAttribute('data-count'),10)||0;
      var card=counter.closest('.gt-stat');
      if(card)card.style.setProperty('--gt-stat-progress',target+'%');
      if(reducedMotion||!('IntersectionObserver' in window)){
        if(card)card.classList.add('is-counted');
        return;
      }
    });
    if(!reducedMotion&&'IntersectionObserver' in window){
      var counterObserver=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(!entry.isIntersecting)return;
          var counter=entry.target;
          var target=parseInt(counter.getAttribute('data-count'),10)||0;
          var card=counter.closest('.gt-stat');
          var startedAt=null;
          var duration=1400;
          if(card)card.classList.add('is-counting');
          // Keep source values intact until the counter is visible.
          counter.textContent='0%';
          function countFrame(timestamp){
            if(startedAt===null)startedAt=timestamp;
            var progress=Math.min((timestamp-startedAt)/duration,1);
            var eased=1-Math.pow(1-progress,3);
            counter.textContent=Math.round(target*eased)+'%';
            if(progress<1){
              window.requestAnimationFrame(countFrame);
            }else{
              counter.textContent=target+'%';
              if(card){card.classList.remove('is-counting');card.classList.add('is-counted')}
            }
          }
          window.requestAnimationFrame(countFrame);
          counterObserver.unobserve(counter);
        });
      },{threshold:.45});
      counters.forEach(function(counter){counterObserver.observe(counter)});
    }
  }
})();
